import { SharedModule } from '../../shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ChangeSecurityQuestionsService } from './change-security-questions.service';
import { ChangeSecurityQuestionsComponent } from './change-security-questions.component';
import { ChangeQuestionsComponent } from './change-questions/change-questions.component';
import { ChangeQuestionsConfirmComponent } from './change-questions-confirm/change-questions-confirm.component';
import { SmsValidationComponent } from './sms-validation-signature/sms-validation-signature.component';
import { ChangeQuestionsResultComponent } from './change-questions-result/change-questions-result.component';

import { MatButtonModule, MatCheckboxModule, MatListModule,
	MatRadioModule, MatSelectModule, MatProgressSpinnerModule, MatNativeDateModule } from '@angular/material';

@NgModule({
	imports: [
		CommonModule,
		SharedModule,
		FormsModule,
		ReactiveFormsModule,
		MatSelectModule,
		MatProgressSpinnerModule
	],
	declarations: [
		ChangeSecurityQuestionsComponent,
		ChangeQuestionsComponent,
		ChangeQuestionsConfirmComponent,
		SmsValidationComponent,
		ChangeQuestionsResultComponent
	],
	providers: [ChangeSecurityQuestionsService]
})
export class ChangeSecurityQuestionsModule { }



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/change-security-questions/change-security-questions.module.ts